module.exports = __webpack_public_path__ + "static/media/advantages2.7dc02a99.png";